import { useEffect, useState } from 'react'

/**
 * Fallback for the resend cooldown when the API does not report one. Matches the
 * backend default (`auth.otp_resend_seconds`); the API's `resend_in` wins whenever
 * it is present, so the countdown never offers a resend the server will refuse.
 */
export const RESEND_SECONDS = 60

/** Seconds left before "resend" is allowed, plus a setter to restart it from the server's value. */
export function useResendCountdown(initial: number) {
  const [seconds, setSeconds] = useState(initial)

  useEffect(() => {
    if (seconds <= 0) return
    const timer = setTimeout(() => setSeconds((s) => Math.max(0, s - 1)), 1000)
    return () => clearTimeout(timer)
  }, [seconds])

  return [seconds, setSeconds] as const
}
